import { defineMessages, FormattedMessage } from 'react-intl';

export const Type = (
  <FormattedMessage defaultMessage='Type' id='plp.allWatchesFilter.type' />
);

export const Diameter = (
  <FormattedMessage
    defaultMessage='Diameter'
    id='plp.allWatchesFilter.diameter'
  />
);

export const CaseMaterial = (
  <FormattedMessage
    defaultMessage='Case material'
    id='plp.allWatchesFilter.caseMaterial'
  />
);

export const DialColor = (
  <FormattedMessage
    defaultMessage='Dial color'
    id='plp.allWatchesFilter.dialColor'
  />
);

export const Price = (
  <FormattedMessage defaultMessage='Price' id='plp.allWatchesFilter.price' />
);

export const Lug = (
  <FormattedMessage defaultMessage='Lug' id='plp.strapsFilter.lug' />
);

export const Material = (
  <FormattedMessage defaultMessage='Material' id='plp.strapsFilter.material' />
);

export const Color = (
  <FormattedMessage defaultMessage='Color' id='plp.strapsFilter.color' />
);

export const StrapLength = (
  <FormattedMessage
    defaultMessage='Strap length'
    id='plp.strapsFilter.strapLength'
  />
);

export const BuckleType = (
  <FormattedMessage defaultMessage='Buckle type' id='plp.strapsFilter.buckle' />
);

export const ReferenceNumber = (
  <FormattedMessage
    defaultMessage='Ref. Number'
    id='plp.allWatchesFilter.refNumber'
  />
);

export const WaterResistance = (
  <FormattedMessage
    defaultMessage='Water resistance'
    id='product.waterResistance'
  />
);

export const Thickness = (
  <FormattedMessage defaultMessage='Thickness' id='Product.Thickness' />
);

export const Weight = (
  <FormattedMessage defaultMessage='Weight' id='Product.Weight' />
);

export const PowerReserve = (
  <FormattedMessage defaultMessage='PowerReserve' id='Product.PowerReserve' />
);

export const Collection = (
  <FormattedMessage defaultMessage='Collection' id='product.collection' />
);

export const StoreType = (
  <FormattedMessage defaultMessage='Store Type' id='product.storeType' />
);
export const messages = defineMessages<string>({
  refNumber: {
    defaultMessage: 'Ref. Number',
    id: 'plp.allWatchesFilter.refNumber',
  },
  buckleType: {
    defaultMessage: 'Buckle type',
    id: 'plp.strapsFilter.buckle',
  },
  caseMaterial: {
    defaultMessage: 'Case material',
    id: 'plp.allWatchesFilter.caseMaterial',
  },
  diameter: {
    defaultMessage: 'Diameter',
    id: 'plp.allWatchesFilter.diameter',
  },
  type: {
    defaultMessage: 'Type',
    id: 'plp.allWatchesFilter.type',
  },
  dialColor: {
    defaultMessage: 'Dial color',
    id: 'plp.allWatchesFilter.dialColor',
  },
  price: {
    defaultMessage: 'Price',
    id: 'plp.allWatchesFilter.price',
  },
  color: {
    defaultMessage: 'Color',
    id: 'plp.strapsFilter.color',
  },
  lug: {
    defaultMessage: 'Lug',
    id: 'plp.strapsFilter.lug',
  },
  material: {
    defaultMessage: 'Material',
    id: 'plp.strapsFilter.material',
  },
  strapLength: {
    defaultMessage: 'Strap length',
    id: 'plp.strapsFilter.strapLength',
  },
});
export const pdpMessages = defineMessages<string>({
  skuChange: {
    defaultMessage: 'CHANGE',
    id: 'pdp.skuChange',
  },
  view3D: {
    defaultMessage: 'VIEW IN 3D',
    id: 'pdp.view3D',
  },
  downloadUserManual: {
    defaultMessage: 'Download the user manual',
    id: 'pdp.downloadUserManual',
  },
  downloadEyewearDeclaration: {
    defaultMessage: 'Declaration of conformity',
    id: 'pdp.downloadEyewearDeclaration',
  },
  swissMade: {
    defaultMessage: 'Swiss made',
    id: 'pdp.swiss-made',
  },
  watchHowToVideos: {
    defaultMessage: 'Watch how-to videos',
    id: 'pdp.watchHowToVideos',
  },
  caseMaterial: {
    defaultMessage: 'Case material',
    id: 'pdp.keyFeatures.caseMaterial',
  },
  keyFeaturesDiameter: {
    defaultMessage: 'Diameter',
    id: 'pdp.keyFeatures.diameter',
  },
  keyFeaturesWaterResistance: {
    defaultMessage: 'Water resistance',
    id: 'pdp.keyFeatures.waterResistance',
  },
  keyFeaturesWaterThickness: {
    defaultMessage: 'Thickness',
    id: 'pdp.keyFeatures.thickness',
  },
  keyFeaturesWaterUnderwater: {
    defaultMessage: 'This watch can be worn underwater',
    id: 'pdp.keyFeatures.underwater',
  },
  keyFeaturesPowerReserve: {
    defaultMessage: 'Power reserve',
    id: 'pdp.keyFeatures.powerReserve',
  },
  technicalDataReference: {
    defaultMessage: 'Reference',
    id: 'pdp.technicalData.reference',
  },
  technicalDataMovement: {
    defaultMessage: 'Movement',
    id: 'pdp.technicalData.movement',
  },
  technicalDataMovementCaliber: {
    defaultMessage: 'Caliber',
    id: 'pdp.technicalData.movementCaliber',
  },
  technicalDataMovementMovement: {
    defaultMessage: 'Movement',
    id: 'pdp.technicalData.movementMovement',
  },
  technicalDataMovementPowerReserve: {
    defaultMessage: 'Power reserve',
    id: 'pdp.technicalData.movementPowerReserve',
  },
  technicalDataMovementChronograph: {
    defaultMessage: 'Chronograph',
    id: 'pdp.technicalData.movementChronograph',
  },
  technicalDataMovementVibration: {
    defaultMessage: 'Vibration',
    id: 'pdp.technicalData.movementVibration',
  },
  technicalDataMovementJewel: {
    defaultMessage: 'Jewel',
    id: 'pdp.technicalData.movementJewel',
  },
  technicalDataMovementCalendar: {
    defaultMessage: 'Calendar',
    id: 'pdp.technicalData.movementCalendar',
  },
  technicalDataCase: {
    defaultMessage: 'Case',
    id: 'pdp.technicalData.case',
  },
  technicalDataCaseMaterial: {
    defaultMessage: 'Case material',
    id: 'pdp.technicalData.case.caseMaterial',
  },
  technicalDataCaseCaseback: {
    defaultMessage: 'Caseback',
    id: 'pdp.technicalData.case.caseBack',
  },
  technicalDataCaseWaterResistance: {
    defaultMessage: 'Water resistance',
    id: 'pdp.technicalData.case.waterResistance',
  },
  technicalDataCaseBezel: {
    defaultMessage: 'Bezel',
    id: 'pdp.technicalData.case.bezel',
  },
  technicalDataCaseCrown: {
    defaultMessage: 'Crown',
    id: 'pdp.technicalData.case.crown',
  },
  technicalDataCaseCrystal: {
    defaultMessage: 'Crystal',
    id: 'pdp.technicalData.case.crystal',
  },
  technicalDataDimensions: {
    defaultMessage: 'Dimensions',
    id: 'pdp.technicalData.dimensions',
  },
  technicalDataDimensionsDiameter: {
    defaultMessage: 'Diameter',
    id: 'pdp.technicalData.dimensions.diameter',
  },
  technicalDataDimensionsThickness: {
    defaultMessage: 'Thickness',
    id: 'pdp.technicalData.dimensions.thickness',
  },
  technicalDataDimensionsHeight: {
    defaultMessage: 'Height (upper lug tip to lower lug tip)',
    id: 'pdp.technicalData.dimensions.height',
  },
  technicalDataDimensionsLugWidth: {
    defaultMessage: 'Lug width (in-between lug)',
    id: 'pdp.technicalData.dimensions.lugWidth',
  },
  technicalDataStrap: {
    defaultMessage: 'Strap',
    id: 'pdp.technicalData.strap',
  },
  technicalDataStrapStrapMaterial: {
    defaultMessage: 'Strap material',
    id: 'pdp.technicalData.strap.strapMaterial',
  },
  technicalDataStrapStrapColor: {
    defaultMessage: 'Strap color',
    id: 'pdp.technicalData.strap.strapColor',
  },
  technicalDataStrapStrapType: {
    defaultMessage: 'Strap type',
    id: 'pdp.technicalData.strap.strapType',
  },
  technicalDataStrapStrapLug: {
    defaultMessage: 'Lug',
    id: 'pdp.technicalData.strap.lug',
  },
  technicalDataStrapStrapBuckleMaterial: {
    defaultMessage: 'Buckle material',
    id: 'pdp.technicalData.strap.buckleMaterial',
  },
  technicalDataStrapStrapBuckleType: {
    defaultMessage: 'Buckle type',
    id: 'pdp.technicalData.strap.buckleType',
  },
  technicalDataStrapStrapBuckleSize: {
    defaultMessage: 'Buckle size',
    id: 'pdp.technicalData.strap.buckleSize',
  },
  technicalDataEyewearFrameDescription: {
    defaultMessage: 'Frame description',
    id: 'pdp.technicalData.frameDescription',
  },
  technicalDataEyewearFrameDescriptionShape: {
    defaultMessage: 'Frame shape',
    id: 'pdp.technicalData.frame.shape',
  },
  technicalDataEyewearFrameDescriptionColor: {
    defaultMessage: 'Frame color',
    id: 'pdp.technicalData.frame.color',
  },
  technicalDataEyewearFrameDescriptionMaterial: {
    defaultMessage: 'Frame material',
    id: 'pdp.technicalData.frame.material',
  },
  eyewearCoreWire: {
    defaultMessage: 'Core wire',
    id: 'pdp.technicalData.frame.coreWire',
  },
  eyewearTempleTipDetail: {
    defaultMessage: 'Temple tip detail',
    id: 'pdp.technicalData.frame.templeTipDetail',
  },
  eyewearFrontalPins: {
    defaultMessage: 'Frontal pins',
    id: 'pdp.technicalData.frame.frontalPins',
  },
  technicalDataEyewearLens: {
    defaultMessage: 'Lens',
    id: 'pdp.technicalData.lens',
  },
  technicalDataEyewearLensSurface: {
    defaultMessage: 'Lens surface',
    id: 'pdp.technicalData.lens.surface',
  },
  technicalDataEyewearLensColor: {
    defaultMessage: 'Lens color',
    id: 'pdp.technicalData.lens.color',
  },
  technicalDataEyewearLensCoating: {
    defaultMessage: 'Lens coating',
    id: 'pdp.technicalData.lens.coating',
  },
  technicalDataEyewearLensUvProtection: {
    defaultMessage: 'UV protection',
    id: 'pdp.technicalData.lens.uvProtection',
  },
  technicalDataEyewearDimensions: {
    defaultMessage: 'Dimensions',
    id: 'pdp.technicalData.dimensions',
  },
  technicalDataEyewearDimensionsFrontalWidth: {
    defaultMessage: 'Frontal width',
    id: 'pdp.technicalData.dimensions.frontalWidth',
  },
  technicalDataEyewearDimensionsTempleLength: {
    defaultMessage: 'Temple length',
    id: 'pdp.technicalData.dimensions.templeLength',
  },
  technicalDataEyewearDimensionsLensWidth: {
    defaultMessage: 'Lens width',
    id: 'pdp.technicalData.dimensions.lensWidth',
  },
  technicalDataEyewearDimensionsBridgeWidth: {
    defaultMessage: 'Bridge width',
    id: 'pdp.technicalData.dimensions.bridgeWidth',
  },
  loadMore: {
    defaultMessage: 'Load More',
    id: 'pdp.technicalData.loadMore',
  },
  learnMore: {
    defaultMessage: 'Learn more',
    id: 'pdp.technicalData.learnMore',
  },
  color: {
    defaultMessage: 'Color',
    id: 'pdp.technicalData.color',
  },
  chooseStrap: {
    defaultMessage: 'Choose Strap',
    id: 'pdp.chooseStrap',
  },
  strapOverflowTooltip: {
    defaultMessage: 'Extra options available on product page',
    id: 'pdp.strapOverflowTooltip',
  },
  noDescriptionAvailable: {
    defaultMessage: 'No description available',
    id: 'pdp.retailerWidget.noDescriptionAvailable',
  },
  pricingDisclaimer: {
    defaultMessage:
      '* Recommended selling prices (taxes excluded) are subject to change without notice. Prices may also vary depending on your strap/bracelet selection.',
    id: 'pdp.retailerWidget.pricingDisclaimer',
  },
  technicalDataTitle: {
    defaultMessage: 'Technical Data',
    id: 'pdp.retailerWidget.technicalDataTitle',
  },
  markdownKeyFeaturesTitle: {
    defaultMessage: 'Key features',
    id: 'pdp.markdown.keyFeaturesTitle',
  },
  markdownTechnicalDataTitle: {
    defaultMessage: 'Technical data',
    id: 'pdp.markdown.technicalDataTitle',
  },
  markdownModelStoryTitle: {
    defaultMessage: 'The Story',
    id: 'pdp.markdown.modelStoryTitle',
  },
  markdownOnlinePurchaseBenefitsTitle: {
    defaultMessage: 'Online Purchase Benefits',
    id: 'pdp.markdown.onlinePurchaseBenefitsTitle',
  },
  markdownWarrantyTitle: {
    defaultMessage: 'Warranty',
    id: 'pdp.markdown.warrantyTitle',
  },
  markdownRelatedProductsTitle: {
    defaultMessage: 'Related Products',
    id: 'pdp.markdown.relatedProductsTitle',
  },
  markdownWarrantyInternational: {
    defaultMessage:
      'This watch comes with a {duration}-year international warranty.',
    id: 'pdp.markdown.warrantyInternational',
  },
  markdownWarrantyExtension: {
    defaultMessage:
      ' Warranty can be extended up to {years} years by registering online.',
    id: 'pdp.markdown.warrantyExtension',
  },
});
